var isWindowRedesignEnabled;
$(document).ready(function () {
    isWindowRedesignEnabled = simPRODefaults.data('attachments_window_redesign');
    $(document).on('click', 'input[type=checkbox].viewAttachment-js', function () {
        // Grid and List view checkboxes for the same file/folder.
        let allCheckboxes = $(this).hasClass('folder') ?
            $("input[type=checkbox][value='" + this.value + "'].viewAttachment-js.folder") :
            $("input[type=checkbox][value='" + this.value + "'].viewAttachment-js.file");
        // Keep both checkboxes in sync, so when user unticks then changes from grid to list view the checkbox is in the same state.
        allCheckboxes.prop("checked", this.checked);
        if (this.checked === false) {
            // uncheck select all when unticked file/folder.
            $('.selectAll').prop("checked", this.checked);
        }

        // If there is at least 1 item selected ensure grid view is in checkbox mode also.
        let selectedCheckboxes = $("input[type=checkbox]:checked.viewAttachment-js").length > 0;
        toggleOptionsGridView(selectedCheckboxes);
        if (!allCheckboxes.closest('table').hasClass('tblGrid')) {
            allCheckboxes.closest('tr').toggleClass('activeRow');
        }
    }).on('click', '#renameAttachmentItemSubmit-js', function() {
        if(checkMandatory($(this).data("mandatory-target"))) {
            ajaxSubmit($(this), $(this).attr('params'));
            let type = $('#editType').val();
            let attachmentName = $('#attachmentName').val();
            if (type == 'attachment') {
                let tmpName = $('#tmpName').val();
                let attachment = $('.allAttachmentDetails[data-tmpname=' + tmpName + ']');
                $('.editAttachmentItem-js[data-tmpname=' + tmpName + ']').data('filename', attachmentName);
                attachment.each(function () {
                    let attachmentNameExtension = attachmentName + '.' + $(this).data('extension');

                    $(this).attr('data-filename', attachmentNameExtension);

                    if ($(this).hasClass('editAttachmentItem-js')) {
                        $(this).find('.fileName').text(attachmentNameExtension);
                    } else if (!$(this).hasClass('thumbnailHolder')) {
                        // add launch icon if not a visible type image
                        if (!$(this).attr('data-is-image')) {
                            attachmentNameExtension += ' <span class="icon-launch"></span>';
                        }
                        $(this).html(attachmentNameExtension);
                    }
                });

                // need to ajax submit for old rename functionality, new modal already submits
                if (!$(this).data('is-window-redesigned')) {
                    ajaxSubmit($(this), $(this).attr('params'));
                }
            } else if (type == 'folder') {
                let folderID = $('#folderID').val();
                let folders = $('.folderEdit_' + folderID);
                folders.each(function () {
                    if ($(this).hasClass('editAttachmentItem-js')) {
                        $(this).data('foldername', attachmentName);
                    }
                });
                $('.folder_' + folderID + ' .folderName').each(function () {
                    let fileName = $(this).find('.fileName');
                    if (fileName.exists()) {
                        fileName.text(attachmentName);
                    } else {
                        $(this).text(attachmentName);
                    }
                });
            }
            $(this).closest(".dialogBox").hide();
        }
    }).on('click', '.toggleAttachmentsSelectAll-js', function () {
        toggleOptionsGridView(this.checked);
    }).on('click', '.toggleAttachmentView-js span', function () {
        // Clicking an option that's not enabled.
        if (!$(this).hasClass('enabled')) {
            return;
        }

        let viewNode = $(this).parent().parent().parent();
        $(this).removeClass('enabled');

        // Clicking grid view
        if ($(this).hasClass('switchViewGrid-js')) {
            $('.switchViewList-js').addClass('enabled');

            // Switch to grid view
            viewNode.find('.listView-js').hide();
            viewNode.find('.gridView-js').fadeIn();
            loadOnscreenItems();
            $(window).on('resize.attachment reload.attachment scroll.attachment', function () {
                loadOnscreenItems();
            });
        }

        // Clicking list view
        if ($(this).hasClass('switchViewList-js')) {
            $('.switchViewGrid-js').addClass('enabled');

            // Switch to list view
            viewNode.find('.gridView-js').hide();
            let listView = viewNode.find('.listView-js');
            listView.fadeIn();
            prepareDocument(listView);
            $(window).off('resize.attachment reload.attachment scroll.attachment');
        }
        if ($(this).find('span').hasClass('icon-grid')) {
            $('.attachmentView-js').val('0');
            $('.attachmentViewBreadcrumb a').each(function () {
                let attr = $(this).attr('params');
                if (typeof attr !== typeof undefined && attr !== false) {
                    let params = $(this).attr('params');
                    params = params.slice(0, -1);
                    $(this).attr('params', params + '0');
                }
            });
        } else {
            $('.attachmentView-js').val('1');
            $('.attachmentViewBreadcrumb a').each(function () {
                let attr = $(this).attr('params');
                if (typeof attr !== typeof undefined && attr !== false) {
                    let params = $(this).attr('params');
                    params = params.slice(0, -1);
                    $(this).attr('params', params + '1');
                }
            });
        }
    }).on('dragenter dragover dragleave', '.attachmentFolderDroppable,.attachmentContainer .folder, #attachmentFilesContainer, .attachmentContainer .attachmentDrop', function(e) {
        if (!$(this).hasClass('dragDisabled')) {
            if (e.type == 'dragleave') {
                $(this).removeClass('highlightDrag');
            } else {
                $(this).addClass('highlightDrag');
            }
        }
    }).on('click', '.removeAttachment-js', function () {
        let $Attachment = $(this);
        if ($Attachment.hasClass("dialogConfirm")) {
            // Show confirm screen handled by dialogConfirm event
        } else {
            let tmpName = $Attachment.data('tmpname');
            //Ajax call to rename the file in the object as well
            let params = "fileNames=" + tmpName + "&action=removeAttachment";
            //updateType specifies what parts of prebuild to be updated
            if (typeof $Attachment.data('updatetype') != 'undefined') {
                params += "&updateType=" + $Attachment.data('updatetype');
            }
            ajaxSubmit(
                $Attachment,
                getAttachmentsPostParams($Attachment, params),
                function ($CurrentAttachment) {
                    $CurrentAttachment.closest('tr').remove();
                }($Attachment)
            );
            if (isWindowRedesignEnabled) {
                toggleSelection();
            }

        }
    }).on('click','.removeAttachmentFolder-js', function () {
        let $attachmentFolder = $(this);
        let folderID = $attachmentFolder.data('folder-id');
        let folderName = $attachmentFolder.data('folder-name');
        let hasChildren = $attachmentFolder.data('haschildren');
        let data = {
            folderID: folderID,
            folderName: folderName,
            hasChildren: hasChildren,
            action: 'removeAttachmentFolder',
        };
        removeAttachmentDialog(data, getAttachmentsPostParams($(this)));
    }).on('click', '.editAttachmentItem-js', function () {
        // Open Modal Window
        let elementID = $(this).data('elementid');
        let $editAttachmentDialog = $('#editAttachmentDialog' + elementID);
        $editAttachmentDialog.show();
        let input = $('#attachmentName' + elementID);
        input.off('focus keyup change paste');
        if ($(this).data('edit-type') == 'attachment') {
            $editAttachmentDialog.find('.title').text(gettext('Rename Attachment'));
            $editAttachmentDialog.find('.fieldHeader').text(gettext('Attachment Name'));
            let filename = $(this).data('filename');
            let extension = $(this).data('extension');
            if (extension !== '') {
                extension = '.' + extension;
            }
            $('#editType').val('attachment');
            $('#tmpName' + elementID).val($(this).data('tmpname'));
            // Strip extension from filename so it isn't editable
            filename = filename.replace(/\.[^/.]+$/, "");
            // validate special characters
            input.val(filename);
            input.attr("maxlength", 150 - extension.length);
            input.select().focus();
            input.on('focus keyup change paste', function () {
                validateAttachmentName($(this), 'attachment');
            });

        } else if ($(this).data('edit-type') == 'folder') {
            $editAttachmentDialog.find('.title').text(gettext('Rename Folder'));
            $editAttachmentDialog.find('.fieldHeader').text(gettext('Folder Name'));
            $('#folderID').val($(this).data('folder-id'));
            $('#editType').val('folder');
            input.val($(this).data('foldername'));
            input.select().focus();
            input.on('focus keyup change paste', function () {
                validateAttachmentName($(this), 'folder');
            });
        }
        let $attachmentDataContainer = $('#attachmentDataContainer-js');
        $attachmentDataContainer.data($(this).data());
        $attachmentDataContainer.data('edit-type', $(this).data('edit-type'));
    }).on('click', '.showImageBox-js', function () {
        //check if feature is enabled
        isWindowRedesignEnabled ? $(this).attachmentsDialog() : showOldWindow($(this));
    }).on('click', '.createFolder-js', function () {
        let createFolderDialog = $('#createFolderDialog');
        createFolderDialog.find('.title').text(gettext('Create Folder'));
        createFolderDialog.show();
        createFolderDialog.find("#folderName").focus();
    }).on("click makeAttachmentEmail", ".attachmentEmail", function(e) {
        let hiddenElement = $(this).next();
        let attachment = $("input[name='formAttachment[]'][value='" + hiddenElement.data('tmp-name') + "']");
        attachment.prop("checked", $(this).prop("checked"));
        if (!$(this).prop("checked")) {
            toogleCheckBoxes(["email"], hiddenElement.data('tmp-name'), false);
            hiddenElement.val("off");
        } else {
            toogleCheckBoxes(["email"], hiddenElement.data('tmp-name'), true);
            toogleCheckBoxes(["public"], hiddenElement.data('tmp-name'), true);
            hiddenElement.val("on");
            if (e.type != 'makeAttachmentEmail') {
                let publicElement = $(this).closest("tr").find(".attachmentPublic");
                if (!publicElement.is(":checked")) {
                    publicElement.prop("checked", true);
                    publicElement.trigger("makeAttachmentPublic");
                }
            }
        }
        if (isWindowRedesignEnabled) {
            toggleSelection();
        }
        attachCalculateSize(true);
        if (e.type != 'makeAttachmentEmail' && $(this).hasClass("attachmentAjax")) {
            ajaxSubmit($(this), getAttachmentsPostParams($(this),"action=selectAttachmentOption"));
        }
    }).on("click makeAttachmentPublic", ".attachmentPublic", function(e) {
        let hiddenElement = $(this).next();
        let attachment = $("input[name='formAttachment[]'][value='" + hiddenElement.data('tmp-name') + "']");
        if (this.checked) {
            toogleCheckBoxes(["public"], hiddenElement.data('tmp-name'), true);
            attachment.parent().removeClass("hide");
        } else {
            toogleCheckBoxes(["public"], hiddenElement.data('tmp-name'), false);
            toogleCheckBoxes(["email"], hiddenElement.data('tmp-name'), false);
            attachment.parent().addClass("hide");
        }
        if (!$(this).prop("checked")) {
            hiddenElement.val("off");
            if (e.type != 'makeAttachmentPublic') {
                let emailElement = $(this).closest("tr").find(".attachmentEmail");
                if (emailElement.is(":checked")) {
                    emailElement.prop("checked", false);
                    emailElement.trigger("makeAttachmentEmail");
                }
            }
        } else {
            hiddenElement.val("on");
        }
        if (e.type != 'makeAttachmentPublic' && $(this).hasClass("attachmentAjax")) {
            ajaxSubmit($(this), getAttachmentsPostParams($(this), "action=selectAttachmentOption"));
        }
        if (isWindowRedesignEnabled) {
            toggleSelection();
        }
        attachCalculateSize(true);
    }).on("click", "input[name='formAttachment[]'], .toggleFormAttachmentsSelectAll-js", function () {
        attachCalculateSize(true);
    });
    if (isWindowRedesignEnabled) {
        toggleSelection();
    }
}).on('click', '.toggleEmailForAttachment-js', function (event) {
    event.preventDefault();
    let tmpName = $(this).closest('a').data('tmpName');
    let options = ["email"];
    toogleCheckBoxes(options, tmpName);
    return false;
}).on('click', '.togglePublicForAttachment-js', function (event) {
    event.preventDefault();
    let tmpName = $(this).closest('a').data('tmpName');
    let options = ["public"];
    toogleCheckBoxes(options, tmpName);
    return false;
}).on('click', '.toggleAllEmailForSelected-js', function () {
    let selectedCheckboxes = $("input.viewAttachment-js[type='checkbox']:checked");
    if (selectedCheckboxes.length === 0) {
        createDialog('alert', gettext('Please select at least one item to attach to email') , gettext('Selection Error'));
        return false;
    }
    toggleAllSelected(selectedCheckboxes, ["email"], true);
    toggleAllSelected(selectedCheckboxes, ["public"], true);
    // Unselect all.
    unselectAll();
    attachCalculateSize(true);
}).on('click', '.toggleAllPublicForSelected-js', function () {
    let selectedCheckboxes = $("input.viewAttachment-js[type='checkbox']:checked");
    if (selectedCheckboxes.length === 0) {
        createDialog('alert', gettext('Please select at least one item to set as public') , gettext('Selection Error'));
        return false;
    }
    toggleAllSelected(selectedCheckboxes, ["email"], false);
    toggleAllSelected(selectedCheckboxes, ["public"], true);
    // Unselect all.
    unselectAll();
    attachCalculateSize(true);
}).on('click', '.toggleAllPrivateForSelected-js', function () {
    let selectedCheckboxes = $("input.viewAttachment-js[type='checkbox']:checked");
    if (selectedCheckboxes.length === 0) {
        createDialog('alert', gettext('Please select at least one item to set as private') , gettext('Selection Error'));
        return false;
    }
    // untick email as well if its ticked.
    toggleAllSelected(selectedCheckboxes, ["email"], false);
    toggleAllSelected(selectedCheckboxes, ["public"], false);
    // Unselect all.
    unselectAll();
    attachCalculateSize(true);
}).on('click', '.removeAllForSelected-js', function () {
    let selectedCheckboxes = getSelectedCheckboxes();
    if (selectedCheckboxes.folders.length === 0 && selectedCheckboxes.files.length === 0) {
        createDialog('alert', gettext('Please select at least one item to delete') , gettext('Selection Error'));
        return false;
    }
    let data = {
        selectedCheckboxes: selectedCheckboxes,
        action: 'removeMultiple',
    };
    removeAttachmentDialog(data, getAttachmentsPostParams($(this)));
}).on('click', '.toggleFormAttachmentsSelectAll-js', function () {

    // Get the current checkbox status of this element
    const newStatus = $(this).prop('checked');

    const $parent = $(this).parent();

    // Find other elements in the same hierarchy with class 'item' and not 'hide'
    $parent.closest('.item').siblings('.item').not('.hide').each(function () {
        // Update the checkbox status in these elements to match the new status
        $(this).find('input[type="checkbox"]').prop('checked', newStatus);
    });
}).on('click', '.formAttachmentsCheckbox-js', function () {
    // Toggle the checked state of the checkbox
    const isChecked = $(this).prop('checked');

    const $parentContainer = $(this).closest('.listBox');
    const $selectAllCheckBox = $parentContainer.find('.toggleFormAttachmentsSelectAll-js');

    if (isChecked) {
        const totalCheckboxes = $parentContainer.find('.item.noHover:not(.hide) input[type="checkbox"]');
        const checkedCheckboxes = totalCheckboxes.filter(':checked');

        // Check all items in the same hierarchy and their checkbox status
        const allChecked = (totalCheckboxes.length === checkedCheckboxes.length);
        if (allChecked) {
            $selectAllCheckBox.prop('checked', true);
        }
    } else {
        $selectAllCheckBox.prop('checked', false);
    }
});

// Get the attachment post params
function getAttachmentsPostParams($CurrentItem, existingParams) {
    let $ContainerWrap = $CurrentItem.closest('.attachmentContainerWrapper');
    if (!$ContainerWrap.exists()) {
        $ContainerWrap = $CurrentItem.closest('.attachmentContainer');
    }

    let $ParamsInput = $ContainerWrap.find('.attachmentPostParams');
    if (typeof $ParamsInput.val() != 'undefined') {
        let trimmedParams = $ParamsInput.val().trim();
        if (existingParams) {
            return existingParams + '&' + trimmedParams;
        }
        return trimmedParams;
    }

    return existingParams;
}

function getRemoveAllUrlParams(paramsData) {
    let params = '';
    let filesData = [];
    params += "action=" + paramsData.action +'&fileNames=';
    if (paramsData["files"] !== undefined) {
        paramsData.files.forEach(function (file) {
            filesData.push(file.tmpFilename);
        });
        params += filesData;
    }
    if (paramsData["folders"] !== undefined) {
        paramsData.folders.forEach(function (folder) {
            if (folder.editType === 'folder' && folder.folderID) {
                params += "&folderIDs[]=" + folder.folderID;
            }
        });
    }

    return params;
}

/**
 * Helper function to unselect all manually.
 * As per current functionality in job list, when an action is performed everything is then unselected.
 */
function unselectAll() {
    // Unselect all.
    let selectAllToggle = $("input.toggleAttachmentsSelectAll-js");
    if (selectAllToggle.is(":checked")) {
        // Checkboxes in list view
        $("input.toggleAttachmentsSelectAll-js").trigger('click');
        // Checkboxes in grid view
        toggleOptionsGridView(false);
    }
}

function toggleAllSelected(selectedCheckboxes, options, toggle) {
    selectedCheckboxes.each(function () {
        let value = $(this).val();
        let className = '.editAttachmentItem-js[data-keyid="' + value + '"]';
        let tmpName = $(className).data('tmpname');
        toogleCheckBoxes(options, tmpName, toggle);
    });
}

function getSelectedCheckboxes() {
    let files = [];
    let folders = [];
    let selectedCheckboxes = $("input.selectedAttachment-js[type='checkbox']:checked");
    selectedCheckboxes.each(function () {
        let value = $(this).val();
        let lineData = $('.editAttachmentItem-js[data-keyid="' + value + '"]');
        let fileName = lineData.data('filename');
        let tmpName = lineData.data('tmpname');
        if (tmpName) {
            files.push({
                'tmpFilename': tmpName,
                'fileName' : fileName
            });
        } else {
            let lineData = $('.editAttachmentItem-js[data-folder-id="' + value + '"]');
            let editType = lineData.attr('data-edit-type');
            let folderName = lineData.attr('data-foldername');
            let hasChildren = lineData.attr('data-haschildren');
            if (editType === 'folder' && value) {
                folders.push({
                    'folderID': value,
                    'editType': editType,
                    'folderName': folderName,
                    'hasChildren': hasChildren
                });
            }
        }
    });
    return {
        'files': files,
        'folders': folders
    };
}

function toggleOptionsGridView(checked) {
    $('.attachmentImageOptionsCheckbox').toggleClass('hide', !checked);
    $('.attachmentImageOptionsMore').toggleClass('hide', checked);
}

function toogleCheckBoxes(options, tmpName, forceValue) {
    let checkBoxes = new Array();
    let hiddenElement = new Array();

    if (options.includes("email")) {
        checkBoxes.push($(".attachmentEmail[data-tmp-name='" + tmpName + "']"));
        hiddenElement.push($("input[type='hidden'][name='attachmentEmail[" + tmpName + "]"));
    }
    if (options.includes("public")) {
        checkBoxes.push($(".attachmentPublic[data-tmp-name='" + tmpName + "']"));
        hiddenElement.push($("input[type='hidden'][name='attachmentPublic[" + tmpName + "]"));
    }

    if (checkBoxes.length > 0) {
        for (let i=0; i < checkBoxes.length ; i++) {
            // Forms tab: The attachment in the list.
            let attachment = $("input[name='formAttachment[]'][value='" + hiddenElement[i].data('tmp-name') + "']");

            // Attachments tab: various elements
            let listViewOptionsPublic = $(".attachmentPublic[data-tmp-name='" + tmpName + "']");
            let listViewOptionsPublicHidden = $("input[type='hidden'][name='attachmentPublic[" + tmpName + "]");
            let listViewOptionsEmail = $(".attachmentEmail[data-tmp-name='" + tmpName + "']");
            let listViewOptionsEmailHidden = $("input[type='hidden'][name='attachmentEmail[" + tmpName + "]");
            let gridViewIconPublic = $("#iconSee[data-tmp-name='" + tmpName + "']");
            let gridViewIconEmail = $("#iconMail[data-tmp-name='" + tmpName + "']");
            //change grid view options text
            let attachmentEmailText = $(".toggleEmailForAttachment-js[data-tmp-name='" + tmpName + "']");
            let gridViewEmailText = attachmentEmailText.children().closest('span.attachmentEmailText-js');
            let attachmentPublicText = $(".togglePublicForAttachment-js[data-tmp-name='" + tmpName + "']");
            let gridViewPublicText = attachmentPublicText.children().closest('span.attachmentPublicText-js');
            switch (forceValue) {
                case false:
                    checkBoxes[i].prop('checked', false);
                    hiddenElement[i].prop('value', 'off');
                    if (checkBoxes[i].hasClass('attachmentEmail')) {
                        gridViewIconEmail.hide();
                        attachment.prop('checked', false);
                        gridViewEmailText.text(gettext('Attach to Email'));
                    }
                    if (checkBoxes[i].hasClass('attachmentPublic')) {
                        gridViewIconPublic.parent().addClass("hide");
                        attachment.parent().addClass("hide");
                        gridViewPublicText.text(gettext('Set as Public'));
                    }
                    break;
                case true:
                    checkBoxes[i].prop('checked', true);
                    hiddenElement[i].prop('value', 'on');
                    if (checkBoxes[i].hasClass('attachmentEmail')) {
                        gridViewIconEmail.show();
                        attachment.prop('checked', true);
                        gridViewEmailText.text(gettext('Remove from Email'));
                    }
                    if (checkBoxes[i].hasClass('attachmentPublic')) {
                        gridViewIconPublic.parent().removeClass("hide");
                        gridViewPublicText.text(gettext('Set as Private'));
                        attachment.parent().removeClass("hide");
                    }
                    break;
                default:
                    // Attach to email clicked
                    if (checkBoxes[i].hasClass('attachmentEmail')) {
                        if (!checkBoxes[i].prop('checked')) {
                            gridViewEmailText.text(gettext('Remove from Email'));
                            gridViewPublicText.text(gettext('Set as Private'));
                            // update icons on grid view
                            gridViewIconPublic.parent().removeClass("hide");
                            gridViewIconEmail.show();
                            // Update the list view.
                            listViewOptionsEmail.prop('checked', true);
                            listViewOptionsEmailHidden.prop('value', 'on');
                            listViewOptionsPublic.prop('checked', true);
                            listViewOptionsPublicHidden.prop('value', 'on');
                            attachment.parent().removeClass("hide");
                            attachment.prop("checked", true);
                        } else {
                            // update icons on grid view
                            gridViewIconEmail.hide();
                            gridViewEmailText.text(gettext('Attach to Email'));
                            // Update the list view.
                            listViewOptionsEmail.prop('checked', false);
                            listViewOptionsEmailHidden.prop('value', 'off');
                            attachment.prop("checked", false);
                        }
                    }
                    // Set as public clicked
                    if (checkBoxes[i].hasClass('attachmentPublic')) {
                        if (!checkBoxes[i].prop('checked')) {
                            gridViewPublicText.text(gettext('Set as Private'));
                            // update icons on grid view
                            gridViewIconPublic.parent().removeClass("hide");
                            // Update the list view.
                            listViewOptionsPublic.prop('checked', true);
                            listViewOptionsPublicHidden.prop('value', 'on');
                            attachment.parent().removeClass("hide");
                            attachment.prop("checked", false);
                        } else {
                            gridViewEmailText.text(gettext('Attach to Email'));
                            gridViewPublicText.text(gettext('Set as Public'));
                            // update icons on grid view
                            gridViewIconPublic.parent().addClass("hide");
                            gridViewIconEmail.hide();
                            // Update the list view.
                            listViewOptionsEmail.prop('checked', false);
                            listViewOptionsEmailHidden.prop('value', 'off');
                            listViewOptionsPublic.prop('checked', false);
                            listViewOptionsPublicHidden.prop('value', 'off');
                            attachment.prop("checked", false);
                            attachment.parent().addClass("hide");
                        }
                    }
            }
        }
    }
    toggleSelection()
}

function validateAttachmentName(inputField, type) {
    if (!$("#attachmentNameTooltip").exists()) {
        let value = inputField.val();
        let error = false;
        let message = '';
        if (value.length === 0 || !value.trim()) {
            error = true;
            message = gettext("%s name can't be empty.").replace("%s", type === "folder" ? gettext("Folder") : gettext("Attachment"));
        } else {
            let copy = value.replace(/[/\\?%*:|"<>@$]/g, "");
            if (value !== copy) {
                error = true;
                inputField.val(copy);
                message = gettext("%s name can't contain any of these characters: / \\ ? % * : | \" < > @ $").replace("%s", type === "folder" ? gettext("Folder") : gettext("Attachment"));
                inputField.val(copy);
            }
        }
        if (error) {
            let tooltipHTML = "<span id='attachmentNameTooltip'><span class='icon-exclamation'></span>" + message + "</span>";
            inputField.attr("title", tooltipHTML);
            let tooltip = createToolTip(inputField, true);
            inputField.one("blur", function () {
                tooltip.remove();
            });
            inputField.focus();
        } else {
            return true;
        }
    }
    return false;
}

function removeAttachmentDialog(data, extraParams) {
    let params = [];
    params.action = data["action"];
    if (data["folderID"]) {
        // single folder delete confirmation
        params["folders"] = [{
            "folderID": data["folderID"],
            "folderName": data["folderName"],
            "editType": 'folder'
        }];
    } else if (typeof data["selectedCheckboxes"] !== undefined) {
        if (data["selectedCheckboxes"].folders) {
            for (let key in data["selectedCheckboxes"].folders) {
                let currentItem = data["selectedCheckboxes"].folders[key];
                if (currentItem.hasChildren === 'true') {
                    data["hasChildren"] = true;
                    break;
                }
            }
        }
        // selected checkboxes i.e files and folders
        if (data["selectedCheckboxes"].files.length > 0) {
            params.files = data["selectedCheckboxes"].files;
        }
        if (data["selectedCheckboxes"].folders.length > 0) {
            params.folders = data["selectedCheckboxes"].folders;
        }
    }
    //check if the folder has any children
    params.hasChildren = data["hasChildren"];

    // dialog set
    let dialogMessage = removeDialog(params);
    let removeParams = getRemoveAllUrlParams(params);
    if (extraParams) {
        removeParams += '&' + extraParams;
    }
    if (dialogMessage !== '') {
        let returnDialog = createDialog("confirm", dialogMessage, gettext("Confirm"));
        returnDialog.on("click", ".dialogContinue", function () {

            let filesRemoved = 0;
            if (typeof params.files !== 'undefined') {
                filesRemoved -= params.files.length;
            }
            ajaxSubmit(
                $(this),
                removeParams,
                function () {
                    let $SelectedCheckboxes = $("input.selectedAttachment-js[type='checkbox']:checked");
                    $SelectedCheckboxes.each(function () {
                        $(this).closest('tr').remove();
                    });
                }
            );
            if (isWindowRedesignEnabled) {
                toggleSelection();
            }
            returnDialog.remove();
        });
    }
}

function removeDialog(params) {
    let dialogMessage = '';
    if (params["hasChildren"] === true) {
        dialogMessage = gettext("The selected folders contain attachments or subfolders. Are you sure you want to remove them?");
    } else {
        if (params["files"] !== undefined && params["folders"] !== undefined) {
            dialogMessage = gettext("Are you sure you want to remove the selected folders and attachments?");
        } else if (params["files"] !== undefined) {
            if (params["files"].length > 1) {
                dialogMessage = gettext("Are you sure you want to remove the selected attachments?");
            } else {
                let fileName = params["files"][0].fileName;
                dialogMessage = sprintf(gettext("Are you sure you want to remove attachment %s?"), "<strong>" + fileName + "</strong>");
            }
        } else if (params["folders"] !== undefined) {
            if (params["folders"].length > 1) {
                dialogMessage = gettext("Are you sure you want to remove the selected folders?");
            } else {
                let folderName = params["folders"][0].folderName;
                dialogMessage = sprintf(gettext("Are you sure you want to remove folder %1$s?"), "<strong>" +  folderName + "</strong>");
            }
        }
    }
    return dialogMessage;
}

function toggleSelection() {
    $('.listBox.listBox-js').each(function() {
        const $container = $(this);

        const $attachments = $container.find('.item.noHover').not('.hide');
        const $checkboxes = $attachments.find('input[type="checkbox"]'); // Corrected selector
        const $selectAllCheckbox = $container.find('.toggleFormAttachmentsSelectAll-js');

        const allChecked = $attachments.length === $checkboxes.filter(':checked').length;
        const allHidden = $attachments.length === 0;  // Checks if all are hidden

        // Set the state of the select all checkbox
        $selectAllCheckbox.prop('checked', allChecked);

        // Toggle the visibility of the select all div element
        $container.find('.noHoverAttachmentForms').toggleClass('hide', allHidden);
    });
}

/**
 * show old UI Window
 */
function showOldWindow($this) {
    let imageTitle = $this.data('filename');
    let imageURL = $this.data('link');
    let elementID = $this.data('elementid');
    let $imageBoxDialog = $('#imageBoxDialog' + elementID);
    if (!$imageBoxDialog.length) {
        $imageBoxDialog = $(window.parent.document).find('#imageBoxDialog');
    }
    $imageBoxDialog.find('.title').text(imageTitle);
    $imageBoxDialog.find('.imageCanvas-js img').attr('src','');
    $imageBoxDialog.find('#lightboxImage').on('load', function () {
        let imageBoxDialogWidth = $imageBoxDialog.find('.lightbox').width() / 2;
        $imageBoxDialog.find('.lightbox').css('margin-left',-(imageBoxDialogWidth));
    });
    $imageBoxDialog.find('.imageCanvas-js img').attr('src',imageURL);
    $imageBoxDialog.find('.download-js').attr('href',imageURL+'&download=1');
    $imageBoxDialog.fadeIn();
}
